import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from "../constent";
import imageCompression from "browser-image-compression";

export const fetchAllStores = createAsyncThunk(
  "stores/fetchAllStores",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/store`);

      // console.log(response.data.data)
      return response.data.data;
    } catch (error) {
      if (error.response?.status === 404) {
        // The server returns 404 when there is no data
        return [];
      }

      return rejectWithValue(error.response?.data || "Failed to load requests");
    }
  }
);

export const AddStores = createAsyncThunk(
  "stores/AddStores",
  async ({ data }, { rejectWithValue }) => {
    try {
      // console.log(selectedSuperCategoryId)
      // console.log("🚀 Starting AddBrand function...");

      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const formData = new FormData();

      formData.append("title_en", data.titleEN);
      formData.append("title_ar", data.titleAR);
      formData.append("subTitle_en", data.subTitleEN);
      formData.append("subTitle_ar", data.subTitleAR);
      formData.append("desc_en", data.descEn);
      formData.append("desc_ar", data.descAr);

      if (data.image instanceof File) {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
          fileType: "image/webp",
        };

        const compressedFile = await imageCompression(data.image, options);
        formData.append("image", compressedFile, `store-${Date.now()}.webp`);
      }

      // console.log("Sending Category with FormData...");

      const createResponse = await axios.post(`${BASE_URL}/store`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          token,
        },
      });

      // console.log("Brand created with image:", createResponse.data);

      return createResponse.data.data;
    } catch (error) {
      console.error("AddService failed:", error.message, error.response?.data);
      return rejectWithValue(error.response?.data || "Failed to add store");
    }
  }
);

export const deleteStoreById = createAsyncThunk(
  "stores/deleteStoreById",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.delete(`${BASE_URL}/store/${id}`, {
        headers: {
          token: token,
        },
      });

      // console.log("✅ Category deleted:", response.data);

      // Can we return the id to update the state in the reducer?
      return id;
    } catch (error) {
      console.error("Delete failed:", error.message, error.response?.data);
      return rejectWithValue(error.response?.data || "Failed to delete Store");
    }
  }
);

export const updateStoreById = createAsyncThunk(
  "stores/updateStoreById",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const formData = new FormData();
      formData.append("title_en", data.titleEN);
      formData.append("title_ar", data.titleAR);
      formData.append("subTitle_en", data.subTitleEN);
      formData.append("subTitle_ar", data.subTitleAR);
      formData.append("desc_en", data.descEN);
      formData.append("desc_ar", data.descAR);

      if (data.image instanceof File) {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
          fileType: "image/webp",
        };

        const compressedFile = await imageCompression(data.image, options);
        formData.append("image", compressedFile, `category-${Date.now()}.webp`);
      }

      const response = await axios.put(`${BASE_URL}/store/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          token: token,
        },
      });

      return response.data.updatedStore || response.data;
    } catch (error) {
      console.error("Update failed:", error.message, error.response?.data);
      return rejectWithValue(error.response?.data || "Failed to update store");
    }
  }
);

export const fetchStoreBySlug = createAsyncThunk(
  "categories/fetchStoreBySlug",
  async (slug, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/store/${slug}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch category by slug"
      );
    }
  }
);

const serviceSlice = createSlice({
  name: "stores",
  initialState: {
    allStores: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllStores.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllStores.fulfilled, (state, action) => {
        state.loading = false;
        state.allStores = action.payload;
      })
      .addCase(fetchAllStores.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default serviceSlice.reducer;

// Export actions and reducer
